import { connect } from 'react-redux';
import { formattedPhoneSelector } from './selectors';
import { PhoneCallConfirmationInfo } from '../../../../components/PhoneCallConfirmationInfo';
export function mapStateToProps(state) {
  return {
    phone: formattedPhoneSelector(state)
  };
}
export var InfoContainer = connect(mapStateToProps)(PhoneCallConfirmationInfo);